<template>
  <div class="content">
    <div class="top-container">
      <div class="left">
        <div class="title-num">
          <span class="title">可提现收入</span>
          <span class="num">￥{{ withdrawalStatisticsObj.canWithdraw || '0.00' }}</span>
        </div>
        <div class="btn gray" @click="clickWithdraw">提现</div>
      </div>
      <div class="right">
        <div class="title-num">
          <span class="title">待结算费用</span>
          <span class="num">￥{{ withdrawalStatisticsObj.waitSettle || '0.00' }}</span>
        </div>
        <div class="btn-box-right">
          <div class="btn-1" @click="settledDetailsPage">查看明细</div>
          <div class="btn-2" @click="exportDetail">导出明细</div>
        </div>
      </div>
    </div>

    <div class="main-container">
      <div class="hasDetail">已发放费用</div>
      <div class="search-box">
        <span class="label-title">结算周期</span>
        <div class="input-item select-two">
          <Select v-model="dateType" :transfer="true" @on-change="changeDateType">
            <Option value="1">按年</Option>
            <Option value="2">按月</Option>
          </Select>
          <DatePicker
            :type="dateType == '1' ? 'year' : 'month'"
            split-panels
            :transfer="true"
            placement="bottom"
            placeholder="选择日期"
            :value="search.date"
            @on-change="search.date = $event"
          ></DatePicker>
        </div>
        <Button type="primary" @click="searchAjax()">查询</Button>
      </div>

      <div class="statistics-box">
        <div class="item first-item">
          <span>合计</span>
          <span class="line"></span>
        </div>
        <div class="item">
          <span class="num">{{ statisticsObj.totalIncomeSubTax || 0 }}</span>
          <span class="title">税后合计(元)</span>
          <span class="line"></span>
        </div>
        <div class="item">
          <span class="num">{{ statisticsObj.methodIncome || 0 }}</span>
          <span class="title">基本法收益(元)</span>
          <span class="line"></span>
        </div>
        <div class="item">
          <span class="num">{{ statisticsObj.baseIncome || 0 }}</span>
          <span class="title">
            基本法外基础费用(元)
            <span class="label">
              <span class="tip-icon">?</span>
              <div class="pop-tip" style="width: 385px">
                <span>含个险首期续期基础费用、团财基础费用（含批单）、后置费用</span>
                <div class="arrow"></div>
              </div>
            </span>
          </span>
          <span class="line"></span>
        </div>
        <div class="item">
          <span class="num">{{ statisticsObj.platformActivityIncome || 0 }}</span>
          <span class="title">无门槛限时加费(元)</span>
          <span class="line"></span>
        </div>
        <div class="item">
          <span class="num">{{ statisticsObj.baseLeaderIncome || 0 }}</span>
          <span class="title">
            团队长管理费(元)
            <span class="label">
              <span class="tip-icon">?</span>
              <div class="pop-tip" style="width: 200px">
                <span>个险首期续期基础费用、后置费用、团财（含批单）的团队长管理费</span>
                <div class="arrow"></div>
              </div>
            </span>
          </span>
          <span class="line"></span>
        </div>
        <div class="item">
          <span class="num">{{ statisticsObj.activityIncome || 0 }}</span>
          <span class="title">
            其他活动收益(元)
            <span class="label">
              <span class="tip-icon">?</span>
              <div class="pop-tip" style="width: 200px">
                <span>除无门槛限时加费的其他活动收益的总和</span>
                <div class="arrow"></div>
              </div>
            </span>
          </span>
          <span class="line"></span>
        </div>
        <div class="item">
          <span class="num">{{ statisticsObj.deduction || 0 }}</span>
          <span class="title">加扣款(元)</span>
          <span class="line"></span>
        </div>
        <div class="item">
          <span class="num">{{ statisticsObj.totalIncome || 0 }}</span>
          <span class="title">税前合计(元)</span>
          <span class="line"></span>
        </div>
        <div class="item">
          <span class="num">{{ statisticsObj.tax || 0 }}</span>
          <span class="title">个税(元)</span>
        </div>
      </div>

      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row }" slot="userName_staffNo">
            <div class="name-status">
              <div class="user-box">
                <i class="dian" :class="{ red: row.workingState == 0, orange: row.isSus == 1 }"></i>
                <span class="user-name">{{ row.staffNo }}</span>
                <span v-if="row.staffNo">/</span>
                <span class="user-name">{{ row.userName }}</span>
              </div>
            </div>
          </template>

          <template slot-scope="{ row }" slot="methodIncomeSlot">
            <Poptip placement="bottom" width="400" @on-popper-show="showMethodIncomePopper(row)" v-if="row.methodIncome != '0.00'">
              <span style="cursor: pointer" class="table-btn" :class="{ 'disabled': row.methodIncome == '0.00' }">{{ row.methodIncome }}</span>
              <div class="api" slot="content">
                <div class="list-box">
                  <loading :isShow="loadingMethodIncome" />
                  <div class="list herder">
                    <span>基本法收益项</span>
                    <span>基本法收益</span>
                  </div>
                  <div class="list" v-for="(item, index) in list" :key="index">
                    <span>{{ item.commissionName }}</span>
                    <span>{{ item.amount }}</span>
                  </div>
                  <div class="no-data" v-if="!list.length">
                    <span>暂无数据</span>
                  </div>
                </div>
              </div>
            </Poptip>
            <span v-else>{{ row.methodIncome }}</span>
          </template>

          <div slot-scope="{ row }" slot="platformActivity">
            <Poptip placement="bottom" width="400" @on-popper-show="showPlatformActivityPopper(row)" v-if="row.platformActivityIncome!=0.00">
              <span style="cursor: pointer" class="table-btn">{{ row.platformActivityIncome }}</span>
              <div class="api" slot="content">
                <Table
                  :columns="[
                    { title: '活动名称', key: 'activityName', align: 'center' },
                    { title: '活动收益', key: 'income', align: 'center' }
                  ]"
                  :data="platformActivityList"
                ></Table>
              </div>
            </Poptip>
            <span v-else>{{ row.platformActivityIncome }}</span>
          </div>

          <div slot-scope="{ row }" slot="activity">
            <Poptip placement="bottom" width="400" @on-popper-show="showActivityPopper(row)" v-if="row.activityIncome != 0.00">
              <span class="table-btn">{{ row.activityIncome }}</span>
              <div slot="content">
                <Table
                  :columns="[
                    { title: '活动名称', key: 'activityName', align: 'center' },
                    { title: '活动收益', key: 'income', align: 'center' }
                  ]"
                  :data="activityList"
                ></Table>
              </div>
            </Poptip>
            <span v-else>{{ row.activityIncome }}</span>
          </div>

          <template slot-scope="{ row }" slot="deductionAction">
            <span class="table-btn" :class="{ 'disabled': row.deduction == '0.00' }" @click="openDeduction(row)">{{ row.deduction }}</span>
          </template>

          <template slot-scope="{ row }" slot="action">
            <div class="action">
              <span class="table-btn" @click="detailsPage(row)">
                <span class="line"></span>
                明细
              </span>
              <span class="table-btn" @click="exportDetailData(row)">导出清单</span>
            </div>
          </template>
        </Table>
        <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="changePage" style="text-align: center; margin-top: 20px" />
      </div>
    </div>

    <!-- 业务员加扣款 -->
    <salesman-deduction ref="salesmanDeduction"></salesman-deduction>

    <!-- 提现 -->
    <numberWithdrawal ref="numberWithdrawal" @ok-withdrawal="getStatistics"></numberWithdrawal>
  </div>
</template>

<script>
import myForm from '@/components/commons/form';
import { mapState } from 'vuex';
import salesmanDeduction from './components/salesmanDeduction';
import numberWithdrawal from './components/numberWithdrawal';
import { common, pageTool } from '@/api/mixins';
import filter from '@/api/filter';

export default {
  components: {
    myForm,
    salesmanDeduction,
    numberWithdrawal
  },
  mixins: [common, pageTool],
  data() {
    return {
      filter,
      waitAvailableAmount: '', //待结算金额
      availableAmount: '', //可提现金额
      statisticsObj: {},
      withdrawalStatisticsObj: {},
      dateType: '1',
      search: {},
      columns: [
        {
          title: '结算周期',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            let settlementDate = params.row.settlementDate;
            return <span>{filter.filterTime(settlementDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '税后合计',
          align: 'center',
          key: 'costAmount',
          minWidth: 120
        },
        {
          title: '结算保单数',
          align: 'center',
          key: 'policyNum',
          minWidth: 100
        },
        {
          title: '结算保费',
          align: 'center',
          key: 'fee',
          minWidth: 120
        },
        {
          title: '基本法收益',
          align: 'center',
          key: 'methodIncome',
          minWidth: 120,
          slot: 'methodIncomeSlot'
        },
        {
          title: '基本法外首期基础费用',
          align: 'center',
          key: 'baseFirstIncome',
          width: 170
        },
        {
          title: '基本法外续期基础费用',
          align: 'center',
          key: 'baseRenewalIncome',
          width: 160
        },
        {
          title: '首年后置费用',
          align: 'center',
          key: 'basePostfIncome',
          width: 160
        },
        {
          title: '无门槛限时加费',
          align: 'center',
          key: 'platformActivityIncome',
          width: 160,
          slot: 'platformActivity'
        },
        {
          title: '团队长首期管理费',
          align: 'center',
          key: 'baseFirstLeaderIncome',
          width: 160
        },
        {
          title: '团队长续期管理费',
          align: 'center',
          key: 'baseRenewalLeaderIncome',
          width: 160
        },
        {
          title: '团队长后置管理费',
          align: 'center',
          key: 'basePostfLeaderIncome',
          minWidth: 130
        },
        {
          title: '其他活动收益',
          align: 'center',
          key: 'activityIncome',
          minWidth: 120,
          slot: 'activity'
        },
        {
          title: '加扣款',
          align: 'center',
          key: 'deduction',
          minWidth: 120,
          slot: 'deductionAction'
        },
        {
          title: '税前合计',
          align: 'center',
          key: 'totalIncome',
          minWidth: 120
        },
        {
          title: '个税',
          align: 'center',
          key: 'tax',
          minWidth: 120
        },
        {
          title: '工资卡号',
          align: 'center',
          key: 'cardNo',
          width: 180
        },
        {
          title: '所属团队',
          align: 'center',
          key: 'groupName',
          minWidth: 130
        },
        {
          title: '所属机构',
          align: 'center',
          key: 'orgName',
          minWidth: 130
        },
        {
          title: '结算职级',
          align: 'center',
          key: 'rankName',
          minWidth: 130,
          render(h, params) {
            let rankName = params.row.rankName;
            return <span>{rankName ? rankName : '-'}</span>;
          }
        },
        {
          title: '使用基本法',
          align: 'center',
          key: 'methodName',
          minWidth: 130,
          render(h, params) {
            let methodName = params.row.methodName;
            return <span>{methodName ? methodName : '-'}</span>;
          }
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 190,
          fixed: 'right'
        }
      ],
      list: [],
      loading: false,
      loadingMethodIncome: false,
      platformActivityList: [],
      activityList: []
    };
  },

  computed: {
    ...mapState(['userInfo'])
  },

  activated() {
    this.searchAjax(false);
    this.getStatistics();
  },

  created() {
    this.searchAjax();
    this.getStatistics();
  },

  methods: {
    changeDateType() {
      this.search.date = '';
    },

    // 统计
    getStatisticsData() {
      let searchObj = {};
      if (this.dateType == '1') {
        searchObj = { year: this.search.date };
      } else {
        searchObj = {
          year: this.search.date.substr(0, 4),
          month: this.search.date.substr(5, 7)
        };
      }
      this.$http({
        url: '/buz/userSalaryDetails/statistics',
        type: 'POST',
        data: {
          groupType: 3,
          ...searchObj
        }
      }).then(res => {
        if (res.data) {
          this.statisticsObj = res.data;
        }
      });
    },

    getList() {
      let searchObj = {};
      if (this.dateType == '1') {
        searchObj = { year: this.search.date };
      } else {
        searchObj = {
          year: this.search.date.substr(0, 4),
          month: this.search.date.substr(5, 7)
        };
      }
      this.listLoading = true;
      this.$http({
        url: '/buz/userSalaryDetails/read/page',
        type: 'POST',
        data: {
          groupType: 3,
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          ...searchObj
        }
      })
        .then(res => {
          res.data.map(item => {
            item.costAmount = (Number(item.totalIncome) - Number(item.tax)).toFixed(2);
          });
          this.tableData = res.data;
          this.total = res.total;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    // 获取统计
    getStatistics() {
      this.$http({
        url: '/buz/userCashWithdrawLog/settle/profileWithSelf',
        type: 'POST',
        data: {}
      }).then(res => {
        this.withdrawalStatisticsObj = res.data;
      });
    },

    // 基本法收益
    showMethodIncomePopper(row) {
      if (row.methodIncome == '0.00') return;
      this.loadingMethodIncome = true;
      this.$http({
        url: '/buz/userCashWithdrawLog/queryIncomeDetail',
        type: 'POST',
        data: {
          userSalaryId: row.id
        }
      }).then(res => {
        this.loadingMethodIncome = false;
        this.list = (res.data.methodIncome && res.data.methodIncome[0].methodIncomeDetails.filter(item => item.amount)) || [];
      });
    },

    // 无门槛限时加费
    showPlatformActivityPopper(row) {
      this.platformActivityList = row.platformActivityVolist;
    },

    // 无门槛活动
    showActivityPopper(row) {
      this.activityList = row.activityVolist;
    },

    // 加扣款
    openDeduction(row) {
      this.$refs.salesmanDeduction.open(row.userId);
    },

    // 明细
    detailsPage(row) {
      this.openPageTabTags('/financialManage/myIncome/detail', {
        reportId: row.reportId,
        userId: row.userId,
        title: `${row.staffNo}/${row.userName}${filter.filterTime(row.settlementDate, 'YYYY-MM-DD')}结算单明细`
      });
    },

    // 导出清单
    exportDetailData(row) {
      let data = {
        reportId: row.reportId,
        userId: row.userId,
        hidden: true
      };
      this.$units.downloadFile('/buz/userSalaryDetails/exportByDetail', data, 'POST');
    },

    searchAjax(reload = true) {
      reload?this.pageNum = 1:'';
      this.getList();
      this.getStatisticsData();
    },

    // 提现
    clickWithdraw() {
      this.$notice.msg('请到APP进行提现');
      // if (this.withdrawalStatisticsObj.canWithdraw == '0.00') {
      //   this.$notice.msg('无可提现金额');
      //   return;
      // }
      // this.$refs.numberWithdrawal.open(this.withdrawalStatisticsObj.canWithdraw);
    },

    // 待结算明细
    settledDetailsPage() {
      this.openPageTabTags('/financialManage/myIncome/settledDetailTabs', {});
    },

    // 导出明细
    exportDetail() {
      let data = { owerTypes: [2, 3], feeStatus: 1 };
      this.$units.downloadFile('/buz/commissionLog/exportUserWaitWithSelf', data, 'POST');
    },

    changePage(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  min-width: 1200px;
  .top-container {
    padding: 0 13px 13px 13px;
    display: flex;
    width: 100%;
    justify-content: space-between;
    .left {
      width: 49.8%;
      height: 180px;
      background-image: url('../../../static/images/revenueManage/1.png');
      background-size: 100% 100%;
      background-position: center center; /* 背景图片居中 */
      background-repeat: no-repeat; /* 背景图片不重复 */
      position: relative;
      .title-num {
        position: absolute;
        left: 140px;
        top: 47px;
        display: flex;
        flex-direction: column;
        .title {
          font-size: 20px;
          color: #fff;
          margin-bottom: 18px;
        }
        .num {
          font-size: 38px;
          font-weight: bold;
          color: #ffffff;
        }
      }
      .btn {
        width: 125px;
        height: 36px;
        border-radius: 2px;
        background: #ffffff;
        font-size: 13px;
        color: #1a78ff;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #ffffff;
        position: absolute;
        right: 50px;
        bottom: 34px;
        cursor: pointer;
        &.gray {
          color: #c5c8ce;
          background-color: #f7f7f7;
          border-color: #dcdee2;
          border: 0;
        }
      }
    }

    .right {
      width: 49.8%;
      height: 180px;
      background-image: url('../../../static/images/revenueManage/2.png');
      background-size: 100% 100%;
      background-position: center center; /* 背景图片居中 */
      background-repeat: no-repeat; /* 背景图片不重复 */
      position: relative;
      .title-num {
        position: absolute;
        left: 150px;
        top: 47px;
        display: flex;
        flex-direction: column;
        .title {
          font-size: 20px;
          color: #fff;
          margin-bottom: 15px;
        }
        .num {
          font-size: 38px;
          font-weight: bold;
          color: #ffffff;
        }
      }
      .btn-box-right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 125px;
        height: 92px;
        position: absolute;
        right: 50px;
        top: 44px;
        .btn-1 {
          width: 125px;
          height: 36px;
          border-radius: 2px;
          background: #ffffff;
          font-size: 13px;
          color: #1a78ff;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid #ffffff;
          cursor: pointer;
        }
        .btn-2 {
          width: 125px;
          height: 36px;
          border-radius: 2px;
          font-size: 13px;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid #ffffff;
          cursor: pointer;
        }
      }
    }
  }

  .main-container {
    min-height: 84vh;
  }

  .hasDetail {
    color: #272933;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 18px;
  }

  .label-title {
    padding-right: 10px;
    font-size: 15px;
    line-height: 30px;
    font-weight: bold;
  }

  .statistics-box {
    display: flex;
    height: 70px;
    background: #f7f7f7;
    margin-bottom: 15px;
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 1;
      font-size: 13px;
      color: #515c6f;
      position: relative;
      .line {
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -10px;
        height: 20px;
        width: 1px;
        background: #dddddd;
      }
      .title {
        color: #515c6f;
        font-size: 13px;
        display: flex;
        align-items: center;
        .label {
          position: relative;
          .tip-icon {
            margin-left: 5px;
            width: 15px;
            height: 15px;
            border-radius: 15px;
            background: transparent;
            background: #a8adb7;
            color: #fff;
            display: inline-block;
            text-align: center;
            line-height: 14px;
            font-size: 14px;
            cursor: pointer;
            top: 50%;
          }

          .tip-icon:hover + .pop-tip {
            opacity: 0.9;
            z-index: 9999;
            display: block;
          }

          .pop-tip {
            position: absolute;
            width: 250px;
            top: 30px;
            display: flex;
            align-items: center;
            text-align: left;
            left: 50%;
            margin-left: -82px;
            padding: 6px 10px;
            display: flex;
            flex-direction: column;
            background-color: #17233d;
            opacity: 0.8;
            display: none;
            border-radius: 4px;

            span {
              font-size: 13px;
              font-weight: 500;
              color: #fff;
            }

            .arrow {
              position: absolute;
              width: 12px;
              height: 12px;
              background-color: #17233d;
              top: -4px;
              left: 78px;
              transform: rotateZ(135deg);
            }
          }
        }
      }
      .num {
        color: #3c464f;
        font-weight: bold;
        margin-bottom: 6px;
        font-size: 16px;
      }
    }
    .first-item {
      flex: 0.5;
    }
  }
}
.disabled {
  color: #515c6f;
}
.name-status {
  align-items: center;
  /deep/ .user-box {
    font-size: 12px;
    .dian {
      display: inline-block;
      flex-shrink: 0;
      width: 5px;
      height: 5px;
      background: #35bf3f;
      border-radius: 50%;
      margin-right: 4px;
      &.red {
        background: #e3461f;
      }
      &.orange {
        background: #ff9900 !important;
      }
    }
    &.text {
      color: #515c6f;
    }
    .user-name {
      font-size: 13px;
      &.dashed {
        border-bottom: 1px dashed #236dff;
      }
      &.line {
        border-bottom: 1px solid #236dff;
      }
    }
    i {
      color: #bababa;
      font-size: 13px;
    }
    .iconduichang {
      margin-left: 4px;
    }
    &.no-token {
      color: #515c6f;
      .user-name {
        cursor: auto;
      }
    }
  }
}
.api {
  padding: 8px 0;
}
.list-box {
  margin-top: 10px;
  .herder {
    background: #f7f7f7;
  }
  .list {
    border: 1px solid #e9e9e9;
    border-top: none;
    display: flex;
    span {
      height: 30px;
      line-height: 30px;
      display: block;
      flex: 1;
      border-right: 1px solid #e9e9e9;
      text-align: center;
    }
    span:last-child {
      border-right: none;
    }
  }
  .list:first-child {
    border-top: 1px solid #e9e9e9;
  }
  .no-data {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    color: #333;
    text-align: center;
    border: 1px solid #e9e9e9;
    border-top: none;
  }
}
.action {
  width: 165px;
  display: flex;
  .table-btn {
    color: #236dff;
    font-size: 12px;
    flex: 1;
    position: relative;
    .line {
      width: 1px;
      height: 12px;
      background: #ced1d5;
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -6px;
    }
  }
}
</style>
